import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

class Input extends (React.Component) {
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.initialValue !== this.props.initialValue) {
            this.setState({
                value: this.props.initialValue || ''
            });
        }
        if (prevState.value !== this.state.value) {
            this.onChange();
        }
    }
    render() {
        const _props = this.props, { type , className , 'data-t': dataT , id , inputRef , max , min , // Omit initialValue from the input props
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        initialValue  } = _props, rest = swcHelpers.objectWithoutProperties(_props, [
            "type",
            "className",
            'data-t',
            "id",
            "inputRef",
            "max",
            "min",
            "initialValue"
        ]);
        const { value  } = this.state;
        return /*#__PURE__*/ React.createElement("input", swcHelpers.extends({}, rest, {
            name: id,
            type: type,
            className: className,
            "data-t": dataT,
            value: value,
            onChange: this.handleChange,
            onBlur: this.handleBlur,
            min: type === 'number' ? min : undefined,
            max: type === 'number' ? max : undefined,
            ref: inputRef
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            value: this.props.initialValue,
            isTouched: false
        };
        this.handleChange = (event)=>{
            const { currentTarget  } = event;
            const { pattern , value  } = currentTarget;
            const regex = pattern ? new RegExp(pattern) : null;
            if (regex && !regex.test(value)) {
                return;
            }
            if (value !== this.state.value) {
                this.setState({
                    value
                });
            }
            event.preventDefault();
        };
        this.onChange = ()=>{
            if (this.props.onChange) {
                this.props.onChange(this.state);
            }
        };
        this.handleBlur = ()=>{
            if (!this.state.isTouched) {
                this.setState({
                    isTouched: true
                }, this.onBlur);
            } else {
                this.onBlur();
            }
        };
        this.onBlur = ()=>{
            if (this.props.onBlur) {
                this.props.onBlur(this.state);
            }
        };
    }
}
Input.defaultProps = {
    id: '',
    'data-t': '',
    type: 'text',
    placeholder: undefined,
    initialValue: '',
    disabled: false
};
var Input$1 = Input;

export { Input$1 as default };
//# sourceMappingURL=Input.js.map
